import {
  Button,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
} from '@chakra-ui/react';
import {
  GetBuyerOfferAnalysisDocument,
  useUpdateBuyerOfferAnalysisMutation,
} from '@client/graphql/__generated__/main-operations';
import { PartyFragment } from '@client/graphql/__generated__/types';
import { useEffect, useState } from 'react';
import { AddOrEditBuyer } from '../../Buyer/AddOrEditBuyer';
import { useBuyerOfferAnalysisContext } from '../Context/BuyerOfferAnalysisContext';

export const EditBuyerOfferAnalysisPartyModal = () => {
  const toast = useToast();
  const {
    buyerOfferAnalysis,
    isEditPartyModalOpen,
    onEditPartyModalClose,
    shouldOpenShareModal,
    setShouldOpenShareModal,
    onShareWithBuyerModalOpen,
  } = useBuyerOfferAnalysisContext();
  const [selectedParty, setSelectedParty] = useState<PartyFragment | undefined>(
    undefined
  );
  const [isEditing, setIsEditing] = useState(false);
  const [showAddBuyerForm, setShowAddBuyerForm] = useState(false);

  const [
    updateBuyerOfferAnalysis,
    { loading: loadingUpdateBuyerOfferAnalysis },
  ] = useUpdateBuyerOfferAnalysisMutation({
    refetchQueries: [GetBuyerOfferAnalysisDocument],
  });

  const onSubmit = async () => {
    const { data } = await updateBuyerOfferAnalysis({
      variables: {
        input: {
          buyerOfferAnalysisId: buyerOfferAnalysis?.id || '',
          partyId: selectedParty?.id,
        },
      },
    });

    if (!data?.updateBuyerOfferAnalysis) {
      toast({
        title: 'Error updating buyer',
        description:
          'Failed to update the buyer information. Please try again.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });

      return;
    }

    if (shouldOpenShareModal) {
      onShareWithBuyerModalOpen();
    }
    setShouldOpenShareModal(false);
    onEditPartyModalClose();
  };

  useEffect(() => {
    if (buyerOfferAnalysis?.party) {
      setSelectedParty(buyerOfferAnalysis.party);
    }
  }, [buyerOfferAnalysis?.party]);

  return (
    <Modal
      isOpen={isEditPartyModalOpen}
      scrollBehavior={showAddBuyerForm ? 'inside' : undefined}
      size="lg"
      onClose={() => {
        onEditPartyModalClose();
        setShouldOpenShareModal(false);
      }}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Offer Scorecard</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel>Select a Buyer</FormLabel>
            <AddOrEditBuyer
              isEditing={isEditing}
              selectedParty={selectedParty}
              setIsEditing={setIsEditing}
              setSelectedParty={setSelectedParty}
              setShowAddBuyerForm={setShowAddBuyerForm}
              showAddBuyerForm={showAddBuyerForm}
            />
          </FormControl>
        </ModalBody>
        <ModalFooter px={8}>
          <Button
            isDisabled={isEditing || !selectedParty}
            isLoading={loadingUpdateBuyerOfferAnalysis}
            width="100%"
            onClick={() => void onSubmit()}
          >
            Update
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
